import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDbli72pYSN52lKtOLDhEBNFbqq7lfwjNY",
  authDomain: "fixture-app-5ad7c.firebaseapp.com",
  databaseURL: "https://fixture-app-5ad7c-default-rtdb.firebaseio.com",
  projectId: "fixture-app-5ad7c",
  storageBucket: "fixture-app-5ad7c.firebasestorage.app",
  messagingSenderId: "12937698944",
  appId: "1:12937698944:web:321faf660ebdc7e2009065"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);